<template>
	<section>
		<TheBox title="Willkommen beim Werberat!" :titleLevel="1">
			<LoginForm v-if="!wantsToResetPassword" @wantsToResetPassword="wantsToResetPassword = !wantsToResetPassword" />
			<PasswordResetForm v-else @cancel="wantsToResetPassword = !wantsToResetPassword" />
		</TheBox>
		<a href="https://www.werberat.at/" title="Werberat-Website aufrufen" class="link" target="_blank">Werberat-Website aufrufen</a>
	</section>
</template>

<script lang="ts">
import LoginForm from '../components/forms/LoginForm.vue';
import TheBox from '../components/TheBox.vue';
import PasswordResetForm from '../components/forms/PasswordResetForm.vue';

export default {
	name: 'LoginView',
	components: {
		LoginForm,
		TheBox,
		PasswordResetForm,
	},

	data() {
		return {
			wantsToResetPassword: false,
		};
	},
	computed: {},
	methods: {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@use '../scss/vars.scss' as *;

#login {
	.link {
		width: 100%;
		text-align: center;
	}
}

@media screen and (min-width: $mobile_maxwidth) {
	#login {
		.link {
			display: none;
		}
	}
}
</style>
